import React, { useEffect, useReducer, useRef, useState } from 'react';
import './Login.css';
import API from '../../Services/Login';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loginSuccess, setLoginSuccess] = useState(false);
    const [selectedCenter, setSelectedCenter] = useState("");

    const selectedCenterRef  = useRef(-1);


    const [centerList, setCenterList] = useState([]);


    // useEffect(() => {
    //     if (localStorage.getItem("selectedProductTypeId") !== null) {
    //         window.location.replace("/CardSwipe");
    //     }
    // }, []);

    const userLogin = async () => {
        try {
            if (!email || !password) {
                toast.error("Email and Password are required!");
                return;
            }
            const payload = { email, password };
            const response = await API.signUp(payload);
            if (response?.status === 200 && response?.data?.success) {
                //toast.success(response?.data?.message);
                setLoginSuccess(true);

                if (response.data.center.length === 1) {
                    // setSelectedCenter(response?.data.center[0].location_id)
                    selectedCenterRef.current = response?.data.center[0].location_id
                    verifyLocationData()
                    return;
                }
                setCenterList(response.data.center || []);
            } else {
                toast.error(response?.data?.message || "Unexpected error occurred!");
            }
        } catch (err) {
            if (err.response) {
                const { status, data } = err.response;
                if (status === 401) {
                    toast.error(data?.message);
                } else if (status === 500) {
                    toast.error("Internal server error. Please try again later.");
                } else {
                    toast.error(data?.errors?.[0]?.msg || "Something went wrong!");
                }
            } else {
                toast.error("Network error. Please check your connection.");
            }
        }
    };

    const verifyLocationData = async () => {
        if (!selectedCenter && selectedCenterRef.current <= 0) {
            toast.error("Please select a center before proceeding.");
            return;
        }

        const payload = {
            email,
            password,
            location_id: selectedCenterRef.current,
        };

        try {
            const response = await API.VerifyLocation(payload);
            if (response?.status === 200 && response?.data?.success) {
                const decodedToken = jwtDecode(response.data?.token);

                localStorage.setItem("token", response.data?.token);
                localStorage.setItem("id", decodedToken?.id);
                localStorage.setItem("location_id", decodedToken?.location_id);
                localStorage.setItem("email", decodedToken?.email);

                console.log("/....", response?.data?.token)
                //toast.success("Location verified successfully");
                window.location.replace("/ProductType");
            } else {
                toast.error(response?.data?.message || "Unexpected error occurred!");
            }
        } catch (error) {
            console.error("Verify location error:", error);
            toast.error("Failed to verify location");
        }
    };

    return (

        <div className="login-wrapper" style={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url("https://skyjumpertrampolinepark.com/wp-content/uploads/2024/11/biggest-chain-01.webp")`, backgroundSize: "cover",
                    backgroundPosition: "center",
                    //opacity: 0.6, // Set your desired opacity here (range 0 to 1)
                }}></div>
            <div className="container py-5 h-100">
                <div className="row justify-content-center align-items-center h-100" style={{ marginTop: "10px" }}>
                    <div className="col-md-6">
                        <div className="card rounded-4 shadow-lg">
                            <div className="card-body p-5">
                                <h3 className="text-center mb-4">Login To Customer POS</h3>
                                <form>
                                    <div className="form-outline mb-4">
                                        <label className="form-label" htmlFor="email">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            className="form-control"
                                            placeholder="Email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            disabled={loginSuccess}
                                        />
                                    </div>
                                    <div className="form-outline mb-4">
                                        <label className="form-label" htmlFor="password">Password</label>
                                        <input
                                            type="password"
                                            id="password"
                                            className="form-control"
                                            placeholder="Password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            disabled={loginSuccess}
                                        />
                                    </div>

                                    {!loginSuccess && (
                                        <div className="text-center mb-4">
                                            <button
                                                onClick={userLogin}
                                                type="button"
                                                className="btn btn-secondary form-control"
                                            >
                                                LOGIN
                                            </button>
                                        </div>
                                    )}

                                    {loginSuccess && centerList.length > 0 && (
                                        <>
                                            <div className="form-outline mb-4">
                                                <label className="form-label" htmlFor="center">Select Center</label>
                                                <select
                                                    className="form-select"
                                                    id="center"
                                                    value={selectedCenter}
                                                    onChange={(e) =>{
                                                        selectedCenterRef.current = e.target.value
                                                        setSelectedCenter(e.target.value)
                                                    }}
                                                >

                                                     <option value="">Select</option>
                                                    {centerList.map((center) => (
                                                        <option
                                                            key={center.id}
                                                            value={center.location_id}
                                                        >
                                                            {center.center_name}
                                                        </option>
                                                    ))}  
                                                    {/* <option value="">Select</option>
                                                    {centerList.length > 1 ? centerList.map((center) => (
                                                        <option
                                                            key={center.id}
                                                            value={center.location_id}
                                                        >
                                                            {center.center_name}
                                                        </option>
                                                    )):setSelectedCenter(centerList?.location_id)} */}
                                                </select>
                                            </div>

                                            <div className="text-center mb-4">
                                                <button
                                                    onClick={verifyLocationData}
                                                    type="button"
                                                    className="btn btn-secondary form-control"
                                                >
                                                    PROCEED
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default Login;
